import { Button, Modal, Select } from "antd";
import { useEffect, useRef, useState } from "react";

const formatDeviceLabel = (label: string) => {
  const regex = /\(([0-9a-fA-F]{4}:[0-9a-fA-F]{4})\)/;

  if (regex.test(label)) { 
    return label.replace(regex, "").trim();
  }
  return label; 
};
  
export default function SpeakerTest({ open, onCancel, devices }:{ open: boolean , onCancel: () => void, devices: MediaDeviceInfo[] }) {
  const audioRef = useRef<any>(null);

  useEffect(() => {
    if (audioRef.current && open) {
      // 设置音频源
      audioRef.current!.src = require("@/assets/sample-9s.mp3");
      audioRef.current!.load();
    }
  }, [open])

  const [isTestOutput, setIsTestOutput] = useState(false);
    
  const [currentOutput, setCurrentOutput] = useState("default");
    

  const handleOutputDeviceChange = async (deviceId: string) => { 
    if (isTestOutput) handleTestOutput();
      
    setCurrentOutput(deviceId);
    if (typeof audioRef.current?.setSinkId === "function") {
      await audioRef.current.setSinkId(deviceId);
    }
  };

  const stopTestOutput = () => { 
    if (!isTestOutput) return;
    audioRef.current!.pause();
    audioRef.current!.currentTime = 0;
    setIsTestOutput(false);
  }

  const handleTestOutput = async () => {
    if (isTestOutput) {
      stopTestOutput()
    } else {
      audioRef.current!.play();
      setIsTestOutput(true);
    }
  };

  const cancel = () => { 
    onCancel();
    stopTestOutput();
  }
  return (
    <Modal
      title="测试扬声器"
      open={open}
      mask={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      wrapClassName={'test-modal-wrap'}
      onCancel={cancel}
    >
      <div>
        <audio src={require("@/assets/sample-9s.mp3")} ref={audioRef}></audio>
        <Select
          placeholder="请选择设备"
          onChange={(v) => handleOutputDeviceChange(v)}
          value={currentOutput}
          style={{ width: "360px" }}
        >
          {devices.map((d) => (
            <Select.Option value={d.deviceId} key={d.deviceId}>
              {formatDeviceLabel(d.label) || d.deviceId}
            </Select.Option>
          ))}
        </Select>

        <Button className="ml10" onClick={handleTestOutput}>
          {isTestOutput ? "停止测试" : "测试"}
        </Button>
      </div>
    </Modal>
  );
}
